import script from "./terminal-template-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./terminal-template-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./terminal-template-dialog.vue?vue&type=style&index=0&id=807aac90&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-807aac90"]])

export default __exports__